import { useDispatch } from 'react-redux';

import { captchaSetActionAfterTokenLoad, captchaSetIsActive } from 'CorePackage/CaptchaModule/actions/captchaActions';
import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';

import { searchGetResultData, searchSetFilter } from '../actions/searchActions';
import { searchFilterMapper } from '../common/searchFilterMapper';
import { IKnmSearchInitFilter } from '../interfaces/IKnmSearchInitFilter';
import styles from './SearchFilters.module.scss';

interface ISearchFilterArrayProps {
  filterName: string;
  filterValue: ISelectOption[];
  filter: Partial<IKnmSearchInitFilter>;
  captchaToken: string | null;
}

export const SearchFilterArray = ({ filterName, filterValue, filter, captchaToken }: ISearchFilterArrayProps) => {
  const dispatch = useDispatch();

  const handleClickFilterArray = (id: string) => () => {
    dispatch(
      searchSetFilter({
        ...filter,
        [filterName]: filterValue?.filter(x => {
          return x.id.toString() !== id;
        }),
      }),
    );
    if (!captchaToken) {
      dispatch(captchaSetActionAfterTokenLoad(searchGetResultData));
      dispatch(captchaSetIsActive(true));
    } else {
      dispatch(searchGetResultData());
    }
  };

  return (
    <div className={styles.FilterWrap}>
      {filterValue.length !== 0 && <div className={styles.FilterLabel}>{searchFilterMapper(filterName)}</div>}
      {filterValue.map(e => (
        <div key={e.id} className={styles.FilterTextWrap}>
          <div className={styles.FilterText}>{e.label}</div>
          <div className={styles.FilterRemove} onClick={handleClickFilterArray(e.id.toString())} />
        </div>
      ))}
    </div>
  );
};
